import React from 'react'
import { ButtonBookmarkIcon } from '../../../components'
import { useViewport } from '../../../utils'

const CardImage = ({bookmark, isMobile, image}) => {
  const isPlaceholder = image && image.toLowerCase().includes('placeholder')
  const { isTablet } = useViewport()
  const size = isMobile ? '140px' : bookmark ? '117px' : isTablet ? '140px' : '180px'

  const styles = isMobile ? {
    backgroundImage: "url('"+image+"')",
    height: size,
    width: '100%'
  } : isTablet ? {
    backgroundImage: "url('"+image+"')",
    height: size,
    minWidth: size
  } : {
    backgroundImage: "url('"+image+"')",
    height: size,
    minWidth: size
  }

  return (
    <div
      className={`bg-no-repeat bg-cover md:mr-3 lg:mr-5 ${isPlaceholder ? 'bg-left' : 'bg-center'} mb-4 md:mb-0 rounded ${bookmark ? 'bookmark' : ''}`}
      style={styles}
    >
      {
        bookmark && isMobile &&
        <ButtonBookmarkIcon className="bg-white m-2 ml-auto"/>
      }
    </div>
  )
}

export { CardImage }
